// @ts-strict-ignore
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LandmarkPanel } from '@form/lm-form.model';
import { lmCardViewFormatter } from '@list/formatters/lm-card-view.formatter';
import { LMFormatterService } from '@list/formatters/lm-formatter.service';
import { LMListCardService } from '@list/services/lm-list-card.service';
import { LMDetailSectionBase } from './lm-detail-section-base';
import { Observable, Observer, of } from 'rxjs';
import { LMUrlUtilService } from '@services/utils';
import { LMCtrlShiftClickBaseComponent, LMRefreshRequest } from '@base/index';
import { LMComponentInfoService, LMContextService } from '@services/index';
import { LMSimpleProgressService } from '../field/simpleprogress/lm-simple-progress.service';

@Component({
  selector: 'lm-detail-section-card',
  standalone: false,
  template: `@if (activated) {<div [innerHtml]="columnInfo"></div>}`,
  styleUrls: [ './lm-detail-section-card.scss' ]
})

export class LMDetailSectionCardComponent extends LMCtrlShiftClickBaseComponent implements LMDetailSectionBase {

  @Input() panel: LandmarkPanel;

  @Input() needsReload: boolean;

  @Input() set fromDataView(dataView) {
    this._fromDataView = dataView;
    this.build();
  }
  get fromDataView() {
    if (this.needsReload) {
      return null;
    }
    return this._fromDataView;
  }

  @Input() public set activated(activated: boolean) {
    this._activated = activated;
    this.build();
  }
  public get activated(): boolean {
    return this._activated;
  }

  @Output() uiLinkEvent = new EventEmitter<any>();
  @Output() detailSectionDisplayed = new EventEmitter<any>();

  public columnInfo: string;

  private _fromDataView: LMDataView;
  private _activated = false;

  constructor(
    public  lmComponentInfoService: LMComponentInfoService,
    public  lmContextService: LMContextService,
    private lmFormatterService: LMFormatterService,
    private lmListCardService: LMListCardService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmSimpleProgressService: LMSimpleProgressService
  ) {
    super(lmComponentInfoService);
  }

  get type() {
    return 'cardview';
  }

  build() {
    if (this.panel && this._fromDataView) {
      this.columnInfo = this.LMCardViewFormatter(0, 0, 0, { displayField: this.panel.displayFields[ 0 ] }, this._fromDataView, null);
      this.detailSectionDisplayed.emit(this);
    }
  }

  LMCardViewFormatter = (
    row: number,
    cell: number,
    value: any,
    columnDef: ListGridColumn,
    dataView: LMDataView,
    dataGrid: SohoDataGridStatic
  ): string => lmCardViewFormatter.format(
    this.lmFormatterService,
    this.lmListCardService,
    this.lmUrlUtilService,
    this.lmSimpleProgressService,
    row,
    cell,
    value,
    columnDef,
    dataView,
    dataGrid,
    'lm-detail-section-card-container',
    this.panel.automationId
  );

  isModified(): boolean {
    return false;
  }

  saveDetailSectionState() {}

  clearDetailSectionState() {
    // noop
  }

  save(callBack: Observer<boolean>) {
    return of(true);
  }

  refresh(request: LMRefreshRequest): Observable<boolean> {
    return of(true);  // TODO: Implement Me!
  }

  public getComponentInfo(additionalInfo?: LMCompInfoAdditionalInfo): LMComponentInfo {
    let cardviewSpec: LMListDisplayField = {};
    if (this.panel.displayFields && this.panel.displayFields[0].type === 'CardView') {
      cardviewSpec = this.panel.displayFields[ 0 ];

      const compConfigInfo: ConfigInfo = {};
      compConfigInfo['personalization'] = cardviewSpec ? cardviewSpec.personalization : undefined;
      compConfigInfo['configuration'] = cardviewSpec ? cardviewSpec.configuration : undefined;
      compConfigInfo['configStamp'] = cardviewSpec ? cardviewSpec.configStamp : 0;
      compConfigInfo['classConfigStamp'] = cardviewSpec ? cardviewSpec.classConfigStamp : 0;

      if (cardviewSpec.type === 'CardView') {
        cardviewSpec['componentType'] =  'CARDVIEW';
      }
      cardviewSpec['configInfo'] = compConfigInfo;

      const formInfo: LMComponentInfo = {
        componentType: 'CARDVIEW',
        name: cardviewSpec ? cardviewSpec.id : undefined,
        cardviewSpec,
        hasConfigAccess: false,
        type: 'card'
      };

      return formInfo;
    }
  }
}
